// 수신자료관리 - ERP_생산자료조회
import { Route, Switch } from 'react-router-dom';
import { lazy, Suspense } from 'react';


const REPPA = lazy(() => import('@/pages/B03/REPPA')); // BODY_SEQ_219
const REPP0 = lazy(() => import('@/pages/B03/REPP0')); // BODY투입계획_상세
const REPP2 = lazy(() => import('@/pages/B03/REPP2')); // BODY투입계획_종합
const REPP4 = lazy(() => import('@/pages/B03/REPP4')); // TRIM투입계획
const REPP6 = lazy(() => import('@/pages/B03/REPP6')); // 서열부품집계_상세
const REPP7 = lazy(() => import('@/pages/B03/REPP7')); // 서열부품집계_종합
const REPP8 = lazy(() => import('@/pages/B03/REPP8')); // 모듈부품집계_상세
const REPP9 = lazy(() => import('@/pages/B03/REPP9')); // 모듈부품집계_종합
const REPPC = lazy(() => import('@/pages/B03/REPPC')); // ALC_Ⅱ계획현황_상세
const REPPD = lazy(() => import('@/pages/B03/REPPD')); // ALC_Ⅱ계획현황_종합
const REPPI = lazy(() => import('@/pages/B03/REPPI')); // WIRE서열계_상세
const REPPJ = lazy(() => import('@/pages/B03/REPPJ')); // WIRE서열계_종합
const REPPS = lazy(() => import('@/pages/B03/REPPS')); //

function B03() {
  return ( 
    <Suspense fallback={null}>
      <Switch>
        <Route path="/B03/REPPA" component={REPPA} />
        <Route path="/B03/REPP0" component={REPP0} />
        <Route path="/B03/REPP2" component={REPP2} />
        <Route path="/B03/REPP4" component={REPP4} />
        <Route path="/B03/REPP6" component={REPP6} />
        <Route path="/B03/REPP7" component={REPP7} />
        <Route path="/B03/REPP8" component={REPP8} />
        <Route path="/B03/REPP9" component={REPP9} />
        <Route path="/B03/REPPC" component={REPPC} />
        <Route path="/B03/REPPD" component={REPPD} />
        <Route path="/B03/REPPI" component={REPPI} />
        <Route path="/B03/REPPJ" component={REPPJ} />
        <Route path="/B03/REPPS" component={REPPS} />
      </Switch>
    </Suspense>
  );
}

export default B03;
